module.exports = __webpack_public_path__ + "img/087-aland-islands.53d8edff.svg";